<template>
  <span v-if="startTime">
    {{ formattedTime }}
  </span>
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      currentlyEnabled: false,
      startTime: null,
      formattedTime: '',
      timerInterval: null
    }
  },
  watch: {
    enabled (value) {
      this.toggleTimer(value)
    }
  },
  mounted () {
    this.toggleTimer(this.enabled)
  },
  beforeUnmount () {
    if (this.timerInterval) {
      clearInterval(this.timerInterval)
    }
  },
  methods: {
    toggleTimer (value) {
      if (this.currentlyEnabled === value) {
        return
      }

      this.currentlyEnabled = value
      if (this.currentlyEnabled) {
        this.startTime = Date.now()
        this.timerInterval = setInterval(this.updateFormattedTime, 1000)
      } else {
        clearInterval(this.timerInterval)
        this.startTime = null
      }
    },
    updateFormattedTime () {
      if (!this.startTime) {
        return ''
      }

      const currentTime = Date.now()
      const secondsDifference = currentTime - this.startTime

      this.$emit('update-timer', Math.round(secondsDifference / 1000))
      this.formattedTime = new Date(secondsDifference).toISOString().substr(11, 8)
    }
  }
}
</script>
